import { Image, View } from "@react-pdf/renderer";
import { MediaEntity } from "models/MediaEntity";

type ImageRowProps = {
  row: MediaEntity[];
  imageGap: number;
  imageMinHeight: number;
  imageMaxHeight: number;
  imagesPerRow: number;
};

const ImageRow: React.FC<ImageRowProps> = ({
  row,
  imageGap,
  imageMinHeight,
  imageMaxHeight,
  imagesPerRow,
}) => {
  return (
    <View
      wrap={false}
      style={{
        display: "flex",
        flexDirection: "row",
        gap: imageGap,
        minHeight: imageMinHeight,
      }}
    >
      {row.map((image) => (
        <View
          key={image.id}
          style={{
            width: `${100 / imagesPerRow}%`,
          }}
        >
          <Image
            src={image.compressedImage ?? image.imgUrl}
            style={{
              width: "100%",
              height: imageMaxHeight,
              minHeight: imageMinHeight,
              objectFit: "contain",
            }}
          />
        </View>
      ))}

      {row.length < imagesPerRow && <View style={{ width: `${100 / imagesPerRow}%` }} />}
    </View>
  );
};

export default ImageRow;
